import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowDownToLineIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.47083 9.92248V1.9845C7.47083 1.7105 7.69381 1.48837 7.96888 1.48837C8.24395 1.48837 8.46693 1.7105 8.46693 1.9845V9.92248C8.46693 10.1965 8.24395 10.4186 7.96888 10.4186C7.69381 10.4186 7.47083 10.1965 7.47083 9.92248Z"
      fill="currentColor"
    />
    <path
      d="M1.49417 12.5688V9.92248C1.49417 9.64848 1.71716 9.42635 1.99223 9.42635C2.26729 9.42635 2.49028 9.64848 2.49028 9.92248V12.5688C2.49037 12.788 2.57787 12.9981 2.73347 13.1531C2.88907 13.3081 3.10001 13.3953 3.32005 13.3953H12.6177C12.8377 13.3953 13.0487 13.3081 13.2043 13.1531C13.3599 12.9981 13.4474 12.788 13.4475 12.5688V9.92248C13.4475 9.64848 13.6705 9.42635 13.9455 9.42635C14.2206 9.42635 14.4436 9.64848 14.4436 9.92248V12.5688C14.4435 13.0511 14.251 13.5136 13.9086 13.8546C13.5662 14.1957 13.1019 14.3875 12.6177 14.3876H3.32005C2.83583 14.3875 2.37159 14.1957 2.02919 13.8546C1.68679 13.5136 1.49426 13.0511 1.49417 12.5688Z"
      fill="currentColor"
    />
    <path
      d="M10.9374 6.26421C11.1319 6.07062 11.4472 6.07051 11.6417 6.26421C11.836 6.45792 11.836 6.77205 11.6417 6.96576L8.32068 10.2729C8.12618 10.4667 7.8109 10.4667 7.6164 10.2729L4.29636 6.96576C4.10186 6.77201 4.10186 6.45796 4.29636 6.26421C4.49086 6.07046 4.80614 6.07046 5.00064 6.26421L7.96854 9.2206L10.9374 6.26421Z"
      fill="currentColor"
    />
  </svg>
);
